//
// Action types
//

export const INITIALIZE_FORM = "INITIALIZE_FORM";
export const CLEAR_FORM = "CLEAR_FORM";

//
// Action creators
//

export function initializeForm(formKey) {
  return { type: INITIALIZE_FORM, formKey };
}

export function clearForm(formKey) {
  return { type: CLEAR_FORM, formKey };
}

function clearFormHandler(state, formKey) {
  // If no form matched, just return the untouched state
  if (!state[formKey]) {
    return state;
  }

  const newState = { ...state };
  delete newState[formKey];
  return newState;
}

//
// Reducer and handlers
//

export function reduceFormInitialization(state, action) {
  switch (action && action.type) {
    case CLEAR_FORM:
      return clearFormHandler(state, action.formKey);

    default:
      return state || {};
  }
}
